import { h } from '@stencil/core';
export const StockQuantityInfo = ({ stockQuantityLabel }) => {
  return (h("div", { class: "stock-quantity-info" }, h("div", { class: "stock-quantity-info__icon-container" }, h("qds-icon", { name: "check-circle" })), h("span", { class: "stock-quantity-info__label" }, stockQuantityLabel)));
};
